import { FunctionComponent } from 'react';
import { Text, View } from '@react-pdf/renderer';
import pdfDocStyles from './pdfDocStyles';

const PdfGrayDot: FunctionComponent<{
  label: string;
  withBorderBottom?: boolean;
  toUpperCase?: boolean;
}> = ({ label, withBorderBottom, toUpperCase }) => {
  return (
    <View
      style={{
        position: 'relative',
        borderBottom: withBorderBottom ? '1px solid #e8e8e8' : undefined,
        marginBottom: 5,
      }}
    >
      <View
        style={{
          position: 'absolute',
          bottom: 3,
          left: 0,
          width: 10,
          height: 10,
          backgroundColor: '#283237',
        }}
      />
      <View style={{ position: 'relative', left: 15, bottom: 2 }}>
        <Text
          style={{
            ...pdfDocStyles.grayDotLabel,
            textTransform: toUpperCase ? 'uppercase' : undefined,
          }}
        >
          {label}
        </Text>
      </View>
    </View>
  );
};

export default PdfGrayDot;
